import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/zh-cn';

// 确保插件被正确扩展
try {
  dayjs.extend(localeData);
  dayjs.extend(relativeTime);
  dayjs.extend(weekday);
} catch (e) {
  console.error('Failed to extend dayjs plugins:', e);
}

// 设置默认语言
dayjs.locale('zh-cn');

// 验证 weekday 方法是否可用
if (typeof dayjs().weekday !== 'function') {
  console.error('dayjs weekday method is not available');
}

export default dayjs;